import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from "gatsby";
import moment from 'moment';

class BlogPostSnippet extends Component {
  render() {
    return (
      <div>
        <h2 className="f2 lh-solid">
          <Link to={this.props.url} className="link underline-hover dark-red">
            {this.props.title}
          </Link>
        </h2>
        {moment(this.props.date).calendar()}
        <p className="f4 lh-copy">{this.props.snippet}</p>
        <p className="f4 tr">
          <Link to={this.props.url}>Read More...</Link>
        </p>
      </div>
    );
  }
}

BlogPostSnippet.propTypes = {
  title: PropTypes.string.isRequired,
  date: PropTypes.string.isRequired,
  snippet: PropTypes.string,
  url: PropTypes.string.isRequired,
};

export default BlogPostSnippet;
